import { forwardRef } from "react";

import { tw } from "~/utils";

export const TableRow = forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr ref={ref} className={tw("even:bg-lightBlue/50", className)} {...props} />
));
TableRow.displayName = "TableRow";
